module.exports = __webpack_public_path__ + "01_short_brown.6bc34a34.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/01_short_brown.png
// module id = iLDr
// module chunks = 0